
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Navigation } from "lucide-react";

export function MobileNav() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="order-last">
          <Navigation className="h-6 w-6" />
        </Button>
      </DialogTrigger>
      <DialogContent className="w-[250px] absolute right-2 top-2 !translate-x-0 !translate-y-0 p-4">
        <nav className="flex flex-col gap-4">
          <a href="/" className="flex items-center gap-2 py-2">
            <span className="text-lg font-semibold">PharmaCare</span>
          </a>
        </nav>
      </DialogContent>
    </Dialog>
  );
}
